import { ConfirmDropProductDto } from "../../dto/network/ConfirmDropProductDto";
import { QrCodeDto } from "../../dto/vending/QrCodeDto";
import { ResPromotionAcquireUserDto } from "../../dto/vending/ResPromotionAcquireUserDto";
import { ResPromotionGiftVoucherDto } from "../../dto/vending/ResPromotionGiftVoucherDto";
import billType, { BillState, IBillAction } from "./bill.type";

const initialState: BillState = {
  isLoading: false,
  error: null,
  bill: undefined,
  promotionVoucherLoyalty: undefined,
  promotionGiftVoucher: undefined,
  promotionAcquireUser: undefined,
  otpAcquireUser: undefined,
  confirmDropProduct: undefined,
  billInfo: undefined,
  qrCode: undefined,
  resBill: undefined,
  charityFund: undefined,
  bankList: undefined
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IBillAction) => {
  switch (action.type) {
    case billType.BILL.LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case billType.BILL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        qrCode: action.payload as QrCodeDto
      };
    case billType.BILL.FAIL:
      return {
        ...state,
        isLoading: false,
        resBill: action.payload
      };
    case billType.BILL.BILL_NUMBER:
      return {
        ...state,
        resBill: action.payload
      };
    case billType.BILL.BILL_QRCODE:
      return {
        ...state,
        resBill: action.payload
      };
    case billType.BILL.START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case billType.BILL.STOP_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case billType.BILL.ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case billType.BILL.VOUCHER:
      return {
        ...state,
        isLoading: false,
        promotionGiftVoucher: action.payload as ResPromotionGiftVoucherDto
      };
    case billType.BILL.LOYALTY:
      return {
        ...state,
        isLoading: false,
        promotionVoucherLoyalty: action.payload as any
      };
    case billType.BILL.CLEAN_DATA:
      return {
        ...state,
        isLoading: false,
        promotionGiftVoucher: undefined,
        promotionAcquireUser: undefined,
        otpAcquireUser: undefined,
        resBill: undefined,
        promotionVoucherLoyalty: undefined,
        confirmDropProduct: undefined,
        billInfo: undefined,
      };
    case billType.BILL.OTP_ACQUIRE_USER:
      return {
        ...state,
        isLoading: false,
        otpAcquireUser: action.payload
      };
    case billType.BILL.ACQUIRE_USER:
      return {
        ...state,
        isLoading: false,
        promotionAcquireUser: action.payload as ResPromotionAcquireUserDto
      };
    case billType.BILL.CLEAR_ACQUIRE_USER:
      return {
        ...state,
        isLoading: false,
        promotionAcquireUser: undefined
      };
    case billType.BILL.GET_CHARITY_FUND:
      return {
        ...state,
        isLoading: false,
        charityFund: action.payload
      };
    case billType.BILL.GET_BANK:
      return {
        ...state,
        isLoading: false,
        bankList: action.payload
      };
    case billType.BILL.RETRY_DROP_PRODUCT:
      return {
        ...state,
        isLoading: false,
        confirmDropProduct: action.payload as ConfirmDropProductDto
      };
    case billType.BILL.UPDATE_SOCKET:
      return {
        ...state,
        isLoading: false,
      };
    case billType.BILL.GET_BILL:
      return {
        ...state,
        isLoading: false,
        billInfo: action.payload as ConfirmDropProductDto
      };
    default:
      return state;
  }
};
